import { memo, useCallback, useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { BzHeading, BzModalBody, BzModalHeader, BzModal, BzButton, BzInputText, BzModalFooter } from "../../components";
import { handleModal } from '../../redux/actions/modals';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from "react-bootstrap";
import { API_CODES, API_ERRORS, API_RESPONSE_STATUS, LOGIN_CONSTANTS } from "../../utils/global_variables";
import { userChangeMPIN, userChangeMPINFailure, userLogout } from "../../redux/actions/auth";
import { setEncryptLocalStorage, setStorageWithMultiTabCheck } from "../../utils/global_functions";

const ChangeMpin = ({ handleDoneMessage, setDoneMessage }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const { objChangeMpinRes } = useSelector(state => state?.auth);
    const userId = useSelector(state => state.auth.userId);

    const [mpin, setMpin] = useState(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
    const [newMpin, setNewMpin] = useState(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
    const [confirmNewMpin, setConfirmNewMpin] = useState(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));

    useEffect(() => {
        if (objChangeMpinRes?.status === API_RESPONSE_STATUS.SUCCESS && objChangeMpinRes?.code === API_CODES.ECODE_SUCCESS) {
            handleHide();
            setDoneMessage('Your M-Pin has been changed successfully!');
            handleDoneMessage();
            setStorageWithMultiTabCheck('SWITCH_TO_USER_ID', userId);
            dispatch(userLogout()).then(() => {
                window.location.replace('/');
            }).catch(() => {
                window.location.replace('/');
            });
        }
    }, [objChangeMpinRes, dispatch]);

    const handleHide = () => {
        setMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
        setNewMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
        setConfirmNewMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
        dispatch(handleModal([{ 'SETTING_MPIN': false }]));
        //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        //to reset validations on input fields
        dispatch(userChangeMPINFailure({}));
        //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - End
    };

    const handleUserMpinOnChange = useCallback((element, index) => {
        if (/^[a-zA-z\s\W]+$/.test(element.value)) {
            setMpin([...mpin.map((d, idx) => ((idx === index ? '' : d)))]);
        }
        else {
            setMpin([...mpin.map((d, idx) => ((idx === index ? element.value : d)))]);
            if (element.value && element.nextSibling) {
                if (!element.value) {
                    element.nextSibling.focus();
                }
            } else { }
        }
    }, [mpin]);

    const handleUserMpinKeyUp = useCallback((e, index) => {
        var key = e.keyCode || e.charCode;
        if (/^[a-zA-z\s\W]+$/.test(e.target.value)) {
        }
        else {
            setMpin([...mpin.map((d, idx) => (idx === index ? e.target.value : d))]);
        }
        if (key === 8 && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
        else {
            if (/^[a-zA-z\s\W]+$/.test(e.target.value)) { }
            else {
                if (e.target.value && e.target.nextSibling) {
                    e.target.nextSibling.focus();
                } else { }
            }
        }
    }, [mpin]);

    const handleUserNewMpinOnChange = useCallback((element, index) => {
        if (/^[a-zA-z\s\W]+$/.test(element.value)) {
            setNewMpin([...newMpin.map((d, idx) => ((idx === index ? '' : d)))]);
        }
        else {
            setNewMpin([...newMpin.map((d, idx) => ((idx === index ? element.value : d)))]);
            if (element.value && element.nextSibling) {
                if (!element.value) {
                    element.nextSibling.focus();
                }
            } else { }
        }
    }, [newMpin]);

    const handleUserNewMpinKeyUp = useCallback((e, index) => {
        var key = e.keyCode || e.charCode;
        if (/^[a-zA-z\s\W]+$/.test(e.target.value)) {
        }
        else {
            setNewMpin([...newMpin.map((d, idx) => (idx === index ? e.target.value : d))]);
        }
        if (key === 8 && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
        else {
            if (/^[a-zA-z\s\W]+$/.test(e.target.value)) { }
            else {
                if (e.target.value && e.target.nextSibling) {
                    e.target.nextSibling.focus();
                } else { }
            }
        }
    }, [newMpin]);

    const handleUserConfirmNewMpinOnChange = useCallback((element, index) => {
        if (/^[a-zA-z\s\W]+$/.test(element.value)) {
            setConfirmNewMpin([...confirmNewMpin.map((d, idx) => ((idx === index ? '' : d)))]);
        }
        else {
            setConfirmNewMpin([...confirmNewMpin.map((d, idx) => ((idx === index ? element.value : d)))]);
            if (element.value && element.nextSibling) {
                if (!element.value) {
                    element.nextSibling.focus();
                }
            } else { }
        }
    }, [confirmNewMpin]);

    const handleUserConfirmNewMpinKeyUp = useCallback((e, index) => {
        var key = e.keyCode || e.charCode;
        if (/^[a-zA-z\s\W]+$/.test(e.target.value)) {
        }
        else {
            setConfirmNewMpin([...confirmNewMpin.map((d, idx) => (idx === index ? e.target.value : d))]);
        }
        if (key === 8 && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
        else {
            if (/^[a-zA-z\s\W]+$/.test(e.target.value)) { }
            else {
                if (e.target.value && e.target.nextSibling) {
                    e.target.nextSibling.focus();
                } else { }
            }
        }
    }, [confirmNewMpin]);

    const handleMpin = () => {
        const udid = uuidv4();
        const oldMpin = mpin.join('');
        const enteredNewMpin = newMpin.join('');
        const enteredConfirmMpin = confirmNewMpin.join('');
        if (enteredNewMpin === enteredConfirmMpin) {
            dispatch(userChangeMPIN(userId, oldMpin, enteredConfirmMpin, window.navigator, udid, window.location.host));
        } else {
            setMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
            setNewMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
            setConfirmNewMpin(new Array(LOGIN_CONSTANTS.MPIN_LENGTH).fill(""));
            dispatch(userChangeMPINFailure({ status: API_RESPONSE_STATUS.ERROR, errors: API_ERRORS.ECODE_REQ_BODY_VALIDATIONS, message: 'Confirm MPIN should be same as New MPIN.' }));
        }
    };

    /* Deepti B. BT-110050 handling mpin data on Enter press start */
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleMpin();
        }
    };
    /* Deepti B. BT-110050 handling mpin data on Enter press end */
    return (
        <BzModal size='sm' show={modals['SETTING_MPIN']} onHide={handleHide} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11}>
                            <BzHeading className='font-medium font-size4 color-text'>M-pin Change</BzHeading>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleHide} className='icon-16 icon-dark icon-close'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 mb-4'>
                        <Col>
                            <div className='font-regular font-size3 color-text mb-2'>Enter Old M-Pin</div>
                            <div className='mpin-wrap'>
                                {
                                    mpin?.map((data, index) => {
                                        return (
                                            <BzInputText
                                                type="password"
                                                name="mpin"
                                                maxLength="1"
                                                className='font-regular'
                                                key={index}
                                                value={data}
                                                onChange={e => handleUserMpinOnChange(e.target, index)}
                                                onKeyUp={e => handleUserMpinKeyUp(e, index)}
                                                onFocus={e => e.target.select()}
                                                onKeyPress={handleKeyPress}
                                            />
                                        );
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-4'>
                        <Col>
                            <div className='font-regular font-size3 color-text mb-2'>Enter New M-Pin</div>
                            <div className='mpin-wrap'>
                                {
                                    newMpin?.map((data, index) => {
                                        return (
                                            <BzInputText
                                                type="password"
                                                name="confirmMpin"
                                                maxLength="1"
                                                className='font-regular'
                                                key={index}
                                                value={data}
                                                onChange={e => handleUserNewMpinOnChange(e.target, index)}
                                                onKeyUp={e => handleUserNewMpinKeyUp(e, index)}
                                                onFocus={e => e.target.select()}
                                                onKeyPress={handleKeyPress}
                                            />
                                        );
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-4'>
                        <Col>
                            <div className='font-regular font-size3 color-text mb-2'>Confirm New M-Pin</div>
                            <div className='mpin-wrap'>
                                {
                                    confirmNewMpin?.map((data, index) => {
                                        return (
                                            <BzInputText
                                                type="password"
                                                name="confirmMpin"
                                                maxLength="1"
                                                className='font-regular'
                                                key={index}
                                                value={data}
                                                onChange={e => handleUserConfirmNewMpinOnChange(e.target, index)}
                                                onKeyUp={e => handleUserConfirmNewMpinKeyUp(e, index)}
                                                onFocus={e => e.target.select()}
                                                onKeyPress={handleKeyPress}
                                            />
                                        );
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                    {objChangeMpinRes && objChangeMpinRes?.status === API_RESPONSE_STATUS.ERROR &&
                        <Row className='g-0'>
                            <Col>
                                <div className='error-msg'>{objChangeMpinRes.message}</div>
                            </Col>
                        </Row>
                    }
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={handleHide}>Close</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={handleMpin}>Save</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(ChangeMpin);

